import { render, staticRenderFns } from "./PriceSavings.vue?vue&type=template&id=0e169f88"
import script from "./PriceSavings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceSavings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports